<template>
    <li class="record">
        <p class="record__title title">
            <span v-if="record.grn_date" class="title__date">{{ record.grn_date }}</span>
            <span v-if="record.grn" class="title__number">ГРН: {{ record.grn }}</span>
        </p>
        <p v-if="record.author" class="record__author"><b>Регистрирующий орган:</b> {{ record.author }}</p>
        <p v-if="record.type" class="record__type"><b>Вид изменения:</b> {{ record.type }}</p>
        <p v-if="isCertificate"><b>Свидетельство:</b> {{ `${record.sv.s} ${record.sv.n} от ${record.sv.d}` }}</p>
        <div v-if="record.docs.length > 0" class="record_docs docs">
            <p class="docs__title"><b>Документы:</b></p>
            <ul class="docs__list">
                <li v-for="(d, i) in record.docs" :key="i" class="docs__item">{{ d.name }}</li>
            </ul>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        record: Object
    },
    computed: {
        isCertificate() { return Object.keys(this.$props.record.sv ?? {}).length }
    }
}
</script>

<style lang="sass" scoped>
.record
    padding: 15px
    &:not(:last-child)
        border-bottom: 1px solid #ddddde
    p
        margin: 6px 0
        font-size: 14px
    .title
        font-size: 20px
        &__number
            color: #005fb3
    .docs
        &__list
            list-style-type: disc
</style>